import { useContext } from 'react';
import { Link } from 'react-router-dom';
import wave from '../../assets/onboarding/wave.gif';
import './IntroStep.scss';
import { UserContext } from '../../context/UserContext';

const IntroStep = () => {
  const { authCapabilities, loginWithEntra } = useContext(UserContext);

  return (
    <div className="intro-step">
      <img className="intro-image" src={wave} alt="Welcome" style={{ marginBottom: "40px" }} />
      <h2>
        <b>ברוכים הבאים ל־mashlom.me</b>
      </h2>
      <p style={{ maxWidth: "600px" }}>
        אנחנו שמחים שבחרת להצטרף אלינו!
        <br />
        הצעד הזה הוא לא רק הרשמה - הוא חלק מהדרך שלך לרפואה חכמה, מדויקת ונעימה יותר. 
      </p>
      {authCapabilities.mode === 'public' ? (
        <button
          type="button"
          className="onboarding-button"
          onClick={() => loginWithEntra({ intent: 'signup' })}
        >
          להתחיל עם Microsoft
        </button>
      ) : (
        <Link to="/onboarding/register" className="onboarding-button">להתחיל להירשם</Link>
      )}
      <Link to="/login" className="login-link">כבר נרשמת? התחבר/י</Link>
    </div>
  );
};

export default IntroStep;